import React, { useEffect, useState } from 'react';
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';
import Images from '../Images';
import { Col, Container, Row, Table } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Scorecard from '../Modal/Scorecard';
import { FaArrowAltCircleLeft } from "react-icons/fa";


function Scorecardanalysis() {

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }, []);

    const navigate = useNavigate()


    return (
        <div>
            <div>
                <Header />
                <div className='inner_page position-relative pb-5'>
                    <img src={Images.elogo} className='elogo' alt="elogo" />
                    <img src={Images.smallround} className='smallround_footer' alt='round'/>
                    
                    <Container className='mt-5'>
                        <button className='themebtn themehoverbtn rounded-1 widthunset mb-3 px-3 fw-600' onClick={()=>navigate(-1)}><FaArrowAltCircleLeft/> Back</button>
                        <div className='vac_border position-relative vac_system rounded-3 py-5 px-4'>
                        <img src={Images.a1logo} className='a1logo' alt='round'/>
                        <img src={Images.a2logo} className='a2logo' alt="elogo" />
                        <img src={Images.a2logo} className='a3logo' alt="elogo" />
                            <Row>
                                <Col xl={8} xxl={10} className='mx-auto position-relative'>
                                <img src={Images.smallround} className='bot_round' alt='round'/>
                                <img src={Images.smallround} className='top_round' alt='round'/>
                                     <h4 className='text-center fw-600 pb-3'>SOC Scorecard Analysis</h4>
                                    <div className='vac_border rounded-4 py-5 px-2 px-sm-4'>
                                   
                                   <Scorecard/>
                                        
                                    </div>
                                    <h5 className='text-center fw-600 mt-4 mb-0'>For more on SOC Scorecard, see the <a target='_blank' className='atag' href='https://school.edaface.com/'>School of Cryptocurrencies</a> (SOC) of EdaFace Academy</h5>
                                </Col>
                            </Row>
                        </div>

                    </Container>
                </div>
                <Footer />
            </div>
        </div>
    )   
}

export default Scorecardanalysis;

